import { SocialNetworkPostStatus, SourceType } from "@/interfaces";
import { PlayerCardsContextData } from "./PlayerCardsContext";
import { UserContextData } from "./UserContext";
import { PlayerCardWidget, Post, PostServices } from "@/services/bedrock";
import { createInitialRecordContextData, createRecordContextData, RecordContextData } from "./RecordContext";

export interface PostContextData extends RecordContextData<Post> {}

export const InitialPostContextData: PostContextData = createInitialRecordContextData<Post>();

const fetchPage = (playerId: number, page: number, perPage: number, search?: string) => {
  const sourceType = [SourceType.CAMPAIGN, SourceType.VIDEO_PROJECT, SourceType.PROMPT, SourceType.POST];
  const socialNetworkPostStatus = [SocialNetworkPostStatus.POSTED];
  return PostServices.getPosts({
    playerId,
    search,
    sourceType,
    socialNetworkPostStatus,
    page,
    perPage,
    sort: "created_date",
    order: "desc",
  });
};

const getRecordFromWidget = (w: PlayerCardWidget): Post | null => {
  return w.owner?.type === "Post" ? w.owner.post ?? null : null;
};

const isRecordNewer = (record: Post, otherRecord?: Post) => {
  if (!otherRecord) return true;
  return record.postDate > otherRecord.postDate;
};

export const PostContext = (PlayerCards: PlayerCardsContextData, User: UserContextData): PostContextData => {
  return createRecordContextData<Post>(PlayerCards, User, "Post", fetchPage, getRecordFromWidget, isRecordNewer);
};
